module.exports = {"greenTemperature":"Green Temperature","hourlyGreenTemperature":"Hourly Green Temperature","periodGreenTemperature":"Green Temperature by Period","selectGolfClubPlaceholder":"Select a golf club.","selectTypePlaceholder":"Select a type.","oneMonth":"1 Month","threeMonths":"3 Months","sixMonths":"6 Months","total":"Total","countUnit":"items","date":"Date","viewDetailOnPc":"View green temperature details by period on a PC.","noData":"No data available."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/gr102.json
// module id = jof3
// module chunks = 2